enum EPISODE_LIST_METADATA_STATE {
  IDLE = 'idle',
  LOADING_STATION_ID = 'loadingStationId',
  LOADING_STATION_METADATA = 'loadingStationMetadata',
  SUCCESS = 'success',
  FAILED = 'failed',
}

enum EPISODE_LIST_STATE {
  IDLE = 'idle',
  LOADING_EPISODES = 'loadingEpisodes',
  SUCCESS = 'success',
  FAILED = 'failed',
}

enum PAGE_DIRECTION {
  NEXT = 'NEXT',
  PREV = 'PREV',
  FIRST = 'FIRST',
  LAST = 'LAST',
}

export { EPISODE_LIST_METADATA_STATE, EPISODE_LIST_STATE, PAGE_DIRECTION };
